import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { SalePinActions } from '.';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class SalesPinsDispatch {
	@Dispatch()
	selectPin = (pin: string): SalePinActions.SelectPin =>
		new SalePinActions.SelectPin(pin);
}
